module.exports = __webpack_public_path__ + "img/phone.cb7389ba.png";